var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"size":"small","filterable":"","disabled":_vm.disabled,"placeholder":"请输入关键词","clearable":_vm.clearable},on:{"change":_vm.handleChange},model:{value:(_vm.item.id),callback:function ($$v) {_vm.$set(_vm.item, "id", $$v)},expression:"item.id"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bb4dd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/OrderUserSelect.vue
// module id = 1643
// module chunks = 0